import { StapleTableCell } from '@insurancemenu/imenu-components-lib';
import React from 'react';

interface Props {
  data?: string;
  customLayout?: React.ReactNode;
  width?: string;
}

const InfoCardTableCell: React.FC<Props> = ({ data, customLayout, width }) => {
  return <StapleTableCell width={width}>{customLayout ?? data}</StapleTableCell>;
};

export default InfoCardTableCell;
